var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mx-4" }, [
    _c("div", { staticClass: "row mb-3 pt-3" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("icon-view", {
            attrs: {
              icon: "fa fa-plus-circle",
              "icon-background": "#fff",
              "icon-color": "#FF7058",
              "icon-size": "16px",
              title: "Pago Adicional",
              variant: "custom-icon-view"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("validation-provider", {
            attrs: { rules: "required|differentFromZero|greaterThanZero" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-input", {
                      staticClass: "payment-amount",
                      attrs: {
                        "custom-error-msg": "",
                        error: errors[0],
                        label: "Pago adicional:",
                        "mask-type": "Money",
                        "prepend-icon": "fa fa-dollar-sign",
                        "prepend-icon-left": true,
                        "prepend-icon-type": "success"
                      },
                      model: {
                        value: _vm.model.amount,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "amount", $$v)
                        },
                        expression: "model.amount"
                      }
                    }),
                    errors[0]
                      ? _c("custom-error", {
                          attrs: {
                            message: errors[0],
                            variant: "no-border mb-3"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-text-area", {
                      attrs: {
                        "custom-error-msg": "Debe completar campo.",
                        error: errors[0],
                        label: "Comentario:",
                        maxlength: 500,
                        "show-char-count": ""
                      },
                      model: {
                        value: _vm.model.comment,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "comment", $$v)
                        },
                        expression: "model.comment"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mt-3 mt-md-0 mt-sm-3 pb-3" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
        },
        [
          _c(
            "action-button",
            {
              attrs: {
                i: "fas fa-times-circle",
                variant: "outline-danger btn-cancel danger px-3 mr-2"
              },
              on: {
                click: function($event) {
                  return _vm.onCancel()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "action-button",
            {
              attrs: { i: "fas fa-check", variant: "success px-3" },
              on: {
                click: function($event) {
                  return _vm.onConfirm()
                }
              }
            },
            [_vm._v(" Confirmar ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }